import script from "./ProcessTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProcessTable.vue?vue&type=script&lang=ts&setup=true"

import "./ProcessTable.vue?vue&type=style&index=0&id=064545bc&lang=css"

const __exports__ = script;

export default __exports__